import React from 'react';
import { Button, ButtonProps, Tooltip } from '@duxton-web/ui';
import scribe from '@grab-x/scribe-web-sdk';
import { useParams } from 'react-router-dom';

import {
  BALANCED_SHUFFLE_TIME_SLICE_MAX_TREATMENTS,
  ExperimentAssignmentStrategy,
  getAssignmentStrategy,
  getVariables,
  isViewMode,
  TreatmentIds,
} from '../../constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '../../contexts/experiment-context';
import { addTreatment } from '../../store/actions/experiment/action-creators';
import { newCreationFlowEvents } from '@/common/Scribe/EventsList';

const TreatmentButton = ({ disabled }: ButtonProps) => {
  const experimentContext = useExperimentContext();
  const { experiment, configurations } = experimentContext;
  const treatmentsLength = configurations?.[0]?.variables?.[0]?.choices?.length;
  const experimentDispatch = useExperimentDispatchContext();

  if (!treatmentsLength) return null;

  return (
    <Button
      disabled={disabled}
      size="small"
      type="default"
      // icon={<AddUniversal />}
      // style={{ marginLeft: 16 }}
      onClick={() => {
        scribe.sendEvent(newCreationFlowEvents.clickAddTreatment.name, {
          experiment_name: experiment?.name,
          STATE_NAME: newCreationFlowEvents.clickAddTreatment.state,
        });

        experimentDispatch(addTreatment());
      }}
    >
      Add Treatment
    </Button>
  );
};

const AddTreatment = () => {
  const params = useParams<{ action: string }>();
  const action = params.action;
  const disabled = isViewMode(action);

  if (disabled) return null;

  const experimentContext = useExperimentContext();
  const { configurations } = experimentContext;
  const variables = getVariables(configurations);
  const treatmentsLength = variables?.[0]?.choices?.length;
  const isUsingBalancedShuffleTimeSliceStrategy =
    getAssignmentStrategy(configurations) ===
    ExperimentAssignmentStrategy.CUSTOM_TIME_SLICE;

  if (treatmentsLength >= TreatmentIds.length) {
    return (
      <Tooltip title="Maximum number of treatment reached">
        <TreatmentButton disabled />
      </Tooltip>
    );
  }

  if (
    isUsingBalancedShuffleTimeSliceStrategy &&
    treatmentsLength >= BALANCED_SHUFFLE_TIME_SLICE_MAX_TREATMENTS
  ) {
    return (
      <Tooltip title="Balanced shuffle strategy can't have more than 3 treatments">
        <TreatmentButton disabled />
      </Tooltip>
    );
  }

  return <TreatmentButton disabled={disabled} />;
};

export default AddTreatment;
